export const ANTITRUST = "antitrust";
export const COPYRIGHT = "copyright";
export const PATENT = "patent";
export const TRADE_SECRET = "tradesecret";
export const TRADEMARK = "trademark";
export const PROFILE = "profile";
export const SECURITIES = "securities";
export const OMNIBUS = "omnibus";
export const UPC = "upc";
